import widow from 'widow';
import objectFitImages from 'object-fit-images'
import debounce from 'debounce';
import helpers from './helpers.js'

export default (function () {
  return {
    init() {
      if (helpers.supportsAnimation) {
        document.querySelector('html').classList.add('has-animation');
      }

      const lastLineEls = document.querySelectorAll('.js-last-line');

      const lastInLine = () => {
        const lastEls = document.querySelectorAll('.js-last-line .is-last-in-row');

        helpers.removeClass(lastEls, 'is-last-in-row');

        [...lastLineEls].forEach((el, i) => {
          const items = el.children;
          let offset = 0;
          [...items].forEach((element, n) => {
            // console.log(element.offsetTop, offset);
            if (n > 0 && element.offsetTop !== offset) {
              element.previousElementSibling.classList.add('is-last-in-row');
            }
            offset = element.offsetTop;
          });
        });
      };

      if (lastLineEls.length) {
        lastInLine();

        window.addEventListener('resize', debounce(() => {
          lastInLine();
        }, 50, false));
      }

      objectFitImages('.article__img img');

      //Fix widows
      widow({
        selectors: ['.section-header__title, .display-heading:not(.card__title):not(.goal__title):not(.grid .display-heading):not(.video-intro-block__heading)'],
        maxLength: 20,
      });

      widow({
        selectors: ['.intro__copy p, .card__desc p'],
        maxLength: 15,
      });
    },
  };
}());
